import {Mutation} from './mutation-types'

export default {
    createActiveMachine({commit}, activeMachine) {
        return commit(Mutation.CREATE_ACTIVE_MACHINE, activeMachine)
    },
    updateActiveMachine({commit}, activeMachine) {
        return commit(Mutation.UPDATE_ACTIVE_MACHINE, activeMachine)
    },
    deleteActiveMachine({commit}, idActiveMachine) {
        return commit(Mutation.DELETE_ACTIVE_MACHINE, idActiveMachine)
    },
    createProductionLineCollapseState({commit}, productionLineCollapseState) {
        return commit(Mutation.CREATE_PRODUCTION_LINE_COLLAPSE_STATE, productionLineCollapseState)
    },
    changeCollapsableProductionLineState({commit}, productionLineId) {
        return commit(Mutation.CHANGE_COLLAPSABLE_PRODUCTION_LINE_STATE, productionLineId)
    }

}
